import React from 'react'
import { Grid, Icon } from 'semantic-ui-react';
import Labels from './../../../../common/Labels';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';

let practiceData;
@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Details Card');
    }
})
class Detail extends React.Component {

    render() {
        practiceData = this.props.selectedPracticeLibrary
        return (
            <Grid columns={4} >
                <Grid.Row>
                    <Grid.Column width={10}>
                        <Labels
                            name="Name"
                            text={practiceData.name} />
                        <Labels
                            name="Description"
                            text={practiceData.description}
                            htmlView={true} />
                        <Labels
                            name="Category"
                            text={<span >
                                {practiceData.baseCategory && practiceData.baseCategory.name} &nbsp; <Icon name="chevron right" />
                                {practiceData.category && practiceData.category.name}&nbsp;<Icon name="chevron right" />
                                {practiceData.subCategory && practiceData.subCategory.name}
                            </span>} />
                    </Grid.Column>
                    <Grid.Column width={6}>
                        <Labels
                            name="Tags"
                            text={practiceData.tags && practiceData.tags.length ?
                                practiceData.tags.map(function (tags, index) {
                                    return <div className="PublishTags" key={index}>{tags}</div>
                                }, this)
                                : <span>No Tags are added.</span>} />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    }
}

export default Detail